// Module
var code = "<label data-bind=\"text: $parent.GetValue(Name)\" data-type=\"text\"></label>";
// Exports
export default code;